import React,{Component} from "react";
import '../css/BottomNav.css';
import {Link} from "react-router-dom";
import SrcDashboard from '../../assets/img/msparc/nav_dashboard.png';
import SrcTrends from '../../assets/img/msparc/nav_trends.png';
import SrcTools from '../../assets/img/msparc/nav_tools.png';
import SrcHelp from '../../assets/img/msparc/nav_help.png';
import SrcProfile from '../../assets/img/msparc/nav_profile.png';

import srcdashselected from '../../assets/img/msparc/nav_dashboard_selected.png';
import srctrendsselected from '../../assets/img/msparc/nav_trends_selected.png';
import srctoolsselected from '../../assets/img/msparc/nav_tools_selected.png';
import srchelpselected from '../../assets/img/msparc/nav_help_selected.png';
import srcprofileselected from '../../assets/img/msparc/nav_profile_selected.png';


// import MenuIcon from '@material-ui/icons/Menu';

 export default class MobNavbar extends Component{
constructor(props){
 super(props)
   this.state={
          dashboardimg:SrcDashboard,
          dashcolor:'#707070',
          trendsimg:SrcTrends,
          trendscolor:'#707070',
          toolsimg:SrcTools,
          toolscolor:'#707070',
          helpimg:SrcHelp,
          helpcolor:'#707070',
          profileimg:SrcProfile,
          profilecolor:'#707070',
          size:'12px'
  
               }
                    };

                    componentDidMount()
                    {

                      
                      if(window.location.pathname.split('/')[2]==='totalemi-dashboard' || window.location.pathname.split('/')[2]==='totalemi-trans-details'){this.dash()}
                     
                      //  else if(window.location.pathname.includes('trends')){this.trends()}
                     
                      //  else if(window.location.pathname.includes('tools')){this.tools()}
                      
                      //  else if(window.location.pathname.includes('help')){this.help()}
                      
                      //  else if(window.location.pathname.includes('profile')){this.profile()}
                         
                    }
                    dash =() =>{
                      this.setState({
                        dashboardimg:srcdashselected,
                        trendsimg:SrcTrends,
                        toolsimg:SrcTools,
                        helpimg:SrcHelp,
                        profileimg:SrcProfile,

                        dashcolor:'#F47626',
                        trendscolor:'#707070',
                        toolscolor:'#707070',
                        helpcolor:'#707070',
                        profilecolor:'#707070',
                       

                      })
                    }
                    trends =() =>{
                      this.setState({
                        dashboardimg:SrcDashboard,
                        trendsimg:srctrendsselected,
                        toolsimg:SrcTools,
                        helpimg:SrcHelp,
                        profileimg:SrcProfile,
          
                        dashcolor:'#707070',
                        trendscolor:'#F47626',
                        toolscolor:'#707070',
                        helpcolor:'#707070',
                        profilecolor:'#707070',
                      })
                    }
                    tools =() =>{
                      this.setState({
                        dashboardimg:SrcDashboard,
                        trendsimg:SrcTrends,
                        toolsimg:srctoolsselected,
                        helpimg:SrcHelp,
                        profileimg:SrcProfile,
                       
                        dashcolor:'#707070',
                        trendscolor:'#707070',
                        toolscolor:'#F47626',
                        helpcolor:'#707070',
                        profilecolor:'#707070',
                      })
                    }
                    help =() =>{
                      this.setState({
                        dashboardimg:SrcDashboard,
                        trendsimg:SrcTrends,
                        toolsimg:SrcTools,
                        helpimg:srchelpselected,
                        profileimg:SrcProfile,
                       
                        dashcolor:'#707070',
                        trendscolor:'#707070',
                        toolscolor:'#707070',
                        helpcolor:'#F47626',
                        profilecolor:'#707070',
                       })
                    }
                    profile =() =>{
                      this.setState(
                        { dashboardimg:SrcDashboard,
                          trendsimg:SrcTrends,
                          toolsimg:SrcTools,
                          helpimg:SrcHelp,
                          profileimg:srcprofileselected,
                        
                        dashcolor:'#707070',
                        trendscolor:'#707070',
                        toolscolor:'#707070',
                        helpcolor:'#707070',
                        profilecolor:'#F47626',
                        })
                    }

 render(){
    return (
   
         <div className="page-container mobile-primary-bar">

         <Link  to="/admin/totalemi-dashboard" className="mobile-primary-bar__link" onClick={this.dash}>    
             <img src={this.state.dashboardimg} className="mobile__icon" />
               <p style={{color:this.state.dashcolor,fontSize:this.state.size}}>Dashboard</p>
         </Link>

         <Link  to="/admin/totalemi-trends" className="mobile-primary-bar__link" onClick={this.trends}>    
             <img src={this.state.trendsimg} className="mobile__icon" />
               <p style={{color:this.state.trendscolor,fontSize:this.state.size}}>Trends</p>
         </Link>  

         <Link  to="/admin/totalemi-tools" className="mobile-primary-bar__link" onClick={this.tools}>    
              <img src={this.state.toolsimg} className="mobile__icon" />
                 <p style={{color:this.state.toolscolor,fontSize:this.state.size}}>Tools</p>
         </Link>
         
         <Link  to="/admin/totalemi-help" className="mobile-primary-bar__link" onClick={this.help}>    
           <img src={this.state.helpimg} className="mobile__icon" />
             <p style={{color:this.state.helpcolor,fontSize:this.state.size}}>Help</p>
         </Link>

         <Link  to="/admin/totalemi-profile" className="mobile-primary-bar__link" onClick={this.profile}>    
              <img src={this.state.profileimg}  className="mobile__icon" />
               <p style={{color:this.state.profilecolor,fontSize:this.state.size}}>Profile</p>
         </Link>  
         </div>
          )
           }



}